<div class="row" style="border-bottom: 2px solid #060671;">
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 ">
      <div style="text-align: right;" class="hmchlogo"  *ngIf="dentalBusinessAreaId === 'null'">
        <img src="assets/images/logo.png" alt="" class=""/>
      </div>
       <div style="text-align: right;" class="hmchlogo" *ngIf="dentalBusinessAreaId !== 'null'">
        <img src="assets/images/Hitech-dental.png" width="150" height="85" alt="" class=""/>
      </div>
    </div>
    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8" style="text-align: center;">
      <div class="">
       <h4 class="hmchsty">{{ dentalBusinessAreaId === 'null' ? 'HI-TECH MEDICAL COLLEGE & HOSPITAL' : 'HI-TECH DENTAL COLLEGE & HOSPITAL' }}</h4>
        <p class="Certified" style="color: red" *ngIf="dentalBusinessAreaId === 'null'">
            (ISO 9001 : 2015 Certified)
          </p>
           <p class="Certified" style="color: red" *ngIf="dentalBusinessAreaId !== 'null'">
            (Under Vigyan Bharati Charitable Trust)
          </p>
        <h4 class="hmchsty" style="margin-top: -8px;" >HEALTH PARK , PANDARA , RASULGARH , BHUBANESWAR - 751025</h4>
        <p class="hmchsty">{{ dentalBusinessAreaId === 'null' ? 'PHONE : (0674) 2371406/407/408' : 'Phone: (0674) 6418484, Fax: (0674) 2371409' }}</p>
        <p class="hmchsty" style="margin-bottom: 18px;" *ngIf="dentalBusinessAreaId !== 'null'">Mobile: 6370953488</p>
        <!-- <h4 _ngcontent-rhe-c212="" class="hmchstyi">OPD PRESCRIPTION</h4> -->
        
        <!-- <h4 class="orcard">OPD REGISTRATION CARD</h4> -->
      </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 htmc">
      <div class="vbctlogo">
        <img src="assets/images/vbct_logo.png" alt="" class=""/>
      </div>
    </div>
  </div>